import { Spinner } from '@shared/components/ui/Spinner';

interface LoadingStateProps {
  message?: string;
  className?: string;
}

/**
 * Componente LoadingState - Muestra un estado de carga con spinner animado
 *
 * Este componente utiliza el componente Spinner con animacion Lottie
 * para mostrar estados de carga en todo el modulo.
 */
export const LoadingState = ({ className = 'min-h-[calc(100vh-150px)]' }: LoadingStateProps) => {
  return (
    <div className={`flex flex-col items-center justify-center w-full ${className}`}>
      {/* Spinner con animacion Lottie - Spinner component with Lottie animation */}
      <Spinner size="md" />
    </div>
  );
};
